import EditableFormattedMessage from "./EditableFormattedMessage"; // Make sure this import is correct

const ScopeReportIntroPageEditable = ({ messages, email, datePassed, pageNumber, pageNumbers, updateMessage, logo }) => (
  <div className="PageCharts-chart">
    <div className="header-logo-box">
      <img
        alt="ppe-logo"
        className="header-logo-img"
        src={logo}
      />
    </div>
    <div className="report-alt-page">
      <div className="centered-title">
            <span className="intro-title">
              <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_TITLE" messages={messages} updateMessage={updateMessage} />
            </span>
      </div>

      <p className="bottom-margin-10">
        <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_WELCOME" messages={messages} updateMessage={updateMessage} />
      </p>

      <p>
        <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_DISTINCTION" messages={messages} updateMessage={updateMessage} />
      </p>

      <ol>
        <li>
          <b>
            <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SELF_EVAL_SUBTITLE" messages={messages} updateMessage={updateMessage} />
          </b>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SELF_EVAL" messages={messages} updateMessage={updateMessage} />
        </li>
        <li>
          <b>
            <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_OBJECTIVE_EVAL_SUBTITLE" messages={messages} updateMessage={updateMessage} />
          </b>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_OBJECTIVE_EVAL" messages={messages} updateMessage={updateMessage} />
        </li>
      </ol>

      <div className="centered-hr">
        <hr className="fullwidth-hr" />
      </div>

      <p className="bottom-margin-10">
        <b>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_HOW_TO_READ_TITLE" messages={messages} updateMessage={updateMessage} />
        </b>
      </p>

      <p className="bottom-margin-10">
        <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_HOW_TO_READ_DESC" messages={messages} updateMessage={updateMessage} />
      </p>

      <p>
        <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTIONS_TITLE" messages={messages} updateMessage={updateMessage} />
      </p>

      <ul>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_PERSONALITY" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[0] ? `${pageNumbers[0]}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_CAPACITIYREASONING" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[1] ? `${pageNumbers[0] + 3}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_COGNITIVE" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[1] ? `${pageNumbers[1]}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_EMOTION" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[2] ? `${pageNumbers[2]}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_ACTION" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[3] ? `${pageNumbers[3]}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_MOTIVATION" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[4] ? `${pageNumbers[4]}` : ""}
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_SECTION_VALUES" messages={messages} updateMessage={updateMessage} /> {pageNumbers && pageNumbers[5] ? `${pageNumbers[5]}` : ""}
        </li>
      </ul>

      <div className="centered-hr">
        <hr className="fullwidth-hr" />
      </div>

      <p>
        <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_KEEP_IN_MIND_TITLE" messages={messages} updateMessage={updateMessage} />
      </p>

      <ul>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_KEEP_IN_MIND_1" messages={messages} updateMessage={updateMessage} />
        </li>
        <li>
          <EditableFormattedMessage msgKey="SCOPE_REPORT_INTRO_KEEP_IN_MIND_2" messages={messages} updateMessage={updateMessage} />
        </li>
      </ul>
    </div>
    <div className="pdf-footer">
      <EditableFormattedMessage msgKey="PAGE" messages={messages} updateMessage={updateMessage} /> {pageNumber}
      <div className="pdf-footer-separator">
        <b>
          <EditableFormattedMessage msgKey="CANDIDATE" messages={messages} updateMessage={updateMessage} />
        </b>
      </div>{" "}
      {email}
      <div className="pdf-footer-separator">
        <b>
          <EditableFormattedMessage msgKey="TEST_DATE" messages={messages} updateMessage={updateMessage} />
        </b> {datePassed}
      </div>
    </div>
  </div>
);

export default ScopeReportIntroPageEditable;